/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { UserCurrentRetrieveStatus200, UserCurrentRetrieveStatus401 } from "../types/UserCurrentRetrieve.ts";

function getUserCurrentRetrieveUrl() {
	const res = { method: "GET", url: `/api/user/current` as const };

	return res;
}

/**
 * @description Текущий пользователь.
 * @summary текущий пользователь
 * {@link /api/user/current}
 */
export async function userCurrentRetrieve(config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<UserCurrentRetrieveStatus200, ResponseErrorConfig<UserCurrentRetrieveStatus401>, unknown>({
		method: "GET",
		url: getUserCurrentRetrieveUrl().url.toString(),
		...requestConfig,
	});

	return res.data;
}
